import React from "react";
import { useTranslation } from "react-i18next";
import {
  type RowStyle,
  type SortChangedEvent,
  themeQuartz,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import type { TableType } from "./Table.type.ts";

export default function TableView<T>(props: TableType<T>) {
  const { t } = useTranslation();

  const { gridRef, loading, columnDef, data, metaOutput, onSortChanged } =
    props;

  const handleSortChanged = (event: SortChangedEvent) => {
    if (!onSortChanged) return;

    const sortModel = event.api
      .getColumnState()
      .filter((col) => col.sort)
      .map((col) => ({
        colId: col.colId ?? "",
        sort: col.sort as "asc" | "desc",
      }));

    onSortChanged(sortModel);
  };

  return (
    <AgGridReact
      key={metaOutput ? "server" : "client"}
      ref={gridRef}
      theme={themeQuartz.withParams({
        accentColor: "#11B418",
        headerBackgroundColor: "#252525",
        headerTextColor: "#FFFFFF",
      })}
      localeText={{
        contains: t("table.general.contains"),
        notContains: t("table.general.notContains"),
        equals: t("table.general.equals"),
        notEqual: t("table.general.notEqual"),
        startsWith: t("table.general.startsWith"),
        endsWith: t("table.general.endsWith"),
        blank: t("table.general.blank"),
        notBlank: t("table.general.notBlank"),
        andCondition: t("table.general.andCondition"),
        orCondition: t("table.general.orCondition"),
        filterOoo: t("table.general.filterOoo"),
      }}
      getRowStyle={(params) => {
        if (params.data?.deactivated) {
          return { color: "gray", fontStyle: "italic" } as RowStyle;
        }
        return {};
      }}
      loading={loading}
      columnDefs={columnDef}
      rowSelection="multiple"
      rowData={data}
      animateRows
      onSortChanged={handleSortChanged}
    />
  );
}
